
import {
  Outlet,
  Link,
  useLocation,
  NavLink,
} from 'react-router-dom';
import React, {
  Suspense, useEffect,
} from 'react';
import {
  useNavigate,
  // useSearchParams,
} from 'react-router-dom';

import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

import { useAuth } from 'react-oidc-context';

import { useState } from 'react';

import { motion } from 'framer-motion';

import { useDispatch, useSelector } from 'react-redux';

import { CircularProgress } from '@mui/material';
import QuickAccessBar from './QuickAccessBar';
import TransparentButton from './TransparentButton';

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: 'tween',
  ease: 'backInOut',
  duration: 0.3,
};

function DigitalWorkerLayout({ tabs, digitalWorkerName, digitalWorkerDescription }) {
  const location = useLocation();

  let navChangedColorHeight;

  if (location.pathname == '/') {
    navChangedColorHeight = window.innerHeight;
  } else {
    navChangedColorHeight = window.innerHeight / 2;
  }

  return (
    <div style={{ textAlign: 'left', position: 'relative', height: '100vh', display: 'flex', flexDirection: 'row' }}>
      {/* <MenuBar /> */}

      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100vh' }}>
        <>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '5vw' }}>
              <div style={{ flex: 2, marginLeft: '2vw', marginRight: '2vw', marginTop: '1.4vw' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <div style={{ marginRight: '1vw' }}>
                    <SupportAgentOutlinedIcon style={{ fontSize: '3.5vw', fontWeight: '300', color: 'rgb(255, 255, 255, 0.7)' }} />
                  </div>
                  <div>
                    <p style={{ fontSize: '1.8vw', marginBottom: '0.4vw', margin: 0, lineHeight: '2vw', color: 'rgb(255, 255, 255, 0.9)' }}>{digitalWorkerName}</p>
                    <p style={{ fontSize: '0.75vw', color: 'rgb(255, 255, 255, 0.8)', margin: 0 }}>{digitalWorkerDescription}</p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: 1, fontSize: '1.8vh', textAlign: 'center', flexDirection: 'row', marginLeft: '1.8vw', marginRight: '2vw', paddingTop: '2vw' }}>
              <div className="blur" style={{ display: 'inline-block', backgroundColor: 'rgb(0, 0, 0, 0.15)', borderRadius: '2vw', padding: '0.3vw' }}>
                {tabs.map(item => (
                  <span
                    style={{}}
                    key={item.name}
                  >
                    <TransparentButton
                      id="workpaper-tab"
                      onClick={item.onClick}
                      selected={location.pathname.includes(item.routeInclude)}
                    >
                      {item.name}
                    </TransparentButton>
                  </span>
                ))}
              </div>
            </div>
            <div style={{ paddingTop: '1.5vw', paddingRight: '1.5vw', flex: 1, display: 'flex', alignItems: 'flex-start' }}>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <QuickAccessBar />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1, height: 'calc(100vh - 5vw)' }}>
            <div className="mainContainer" style={{ flex: 1, display: 'flex', overflow: 'auto' }}>
              <div style={{ flex: 1, width: '100%' }}>
                <div style={{ height: 'calc(100vh - 6vw)', overflowY: 'auto' }}>
                  <Suspense>
                    <motion.div
                      key={location.pathname}
                      initial="initial"
                      animate="in"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                      <Outlet />
                    </motion.div>
                  </Suspense>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>

    </div>

  );
}

export default DigitalWorkerLayout;


